export default "__VITE_PUBLIC_ASSET__18a1ea84__"